// eslint-disable-next-line jira/filename-case
import { createHook } from './useOnboardingFlowsActions.tsx';
import type { CollectionsTourSteps } from './GlobalFieldsTourSteps.types.tsx';
import {
	getCollectionsTourDismissed,
	getTourSpotlightStep,
	getCollectionsIntroductionDismissed,
	getCollectionsIntroductionPrerequisiteDismissalsMet,
} from './getCollectionsTourDismissed.tsx';

export const useCollectionsTourDismissed: () => boolean | undefined = createHook(
	getCollectionsTourDismissed,
);
export const useTourSpotlightStep: () => CollectionsTourSteps | null =
	createHook(getTourSpotlightStep);
export const useCollectionsIntroductionDismissed: () => boolean | undefined = createHook(
	getCollectionsIntroductionDismissed,
);
export const useCollectionsIntroductionPrerequisiteDismissalsMet: () => boolean | undefined =
	createHook(getCollectionsIntroductionPrerequisiteDismissalsMet);
